// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3rf4A","calendarButtons":"ClockData_calendarButtons__1kmu4"};